import { render, staticRenderFns } from "./AgentFilesPanel.vue?vue&type=template&id=131dedde&scoped=true"
import script from "./AgentFilesPanel.vue?vue&type=script&lang=js"
export * from "./AgentFilesPanel.vue?vue&type=script&lang=js"
import style0 from "./AgentFilesPanel.vue?vue&type=style&index=0&id=131dedde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131dedde",
  null
  
)

export default component.exports